import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=253aed32&scoped=true&"
import script from "./ReportsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReportsTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReportsTable.vue?vue&type=style&index=0&id=253aed32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253aed32",
  null
  
)

export default component.exports